export default __webpack_public_path__ + "static/media/img-clipart-wwd-question.80a897dc.png";